import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { PlatformService } from '@core/services/platform.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
    constructor(
        private readonly authenticationService: AuthenticationService,
        private readonly platformService: PlatformService
    ) {}

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.platformService.isBrowser) {
            return next.handle(request);
        }

        return this.authenticationService.loginState$.pipe(
            take(1),
            switchMap(loggedInState => {
                const { loggedIn } = loggedInState;
                const storedToken = this.authenticationService.getActiveToken();

                if (!loggedIn || !storedToken) {
                    return next.handle(request);
                }

                return next.handle(
                    request.clone({
                        setHeaders: { Authorization: `Bearer ${storedToken}` }
                    })
                );
            })
        );
    }
}
